import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

type Meta = {
  types: Record<string, string>;
};

interface LookupData {
  id: string;
  displayName: string;
  type: string;
}

interface LookupResponse {
  data: LookupData[];
  meta: Meta;
}

interface CreateLookupRequest {
  type: string;
  displayName: string;
}

interface UpdateLookupRequest {
  type: string;
  id: string;
  displayName: string;
}

interface DeleteLookupRequest {
  type: string;
  id: string;
}

export const RemarksApi = createApi({
  reducerPath: 'RemarksApi',
  baseQuery,
  tagTypes: ['Lookup'],
  endpoints: builder => ({
    getLookups: builder.query<LookupResponse, string | void>({
      query: type => {
        return `/manage/lookups/${type}`;
      },
      providesTags: ['Lookup'],
    }),
    createLookup: builder.mutation<LookupResponse, CreateLookupRequest>({
      query: ({ type, displayName }) => ({
        url: `/manage/lookups/${type}`,
        method: 'POST',
        body: { displayName },
      }),
      invalidatesTags: ['Lookup'],
    }),
    updateLookup: builder.mutation<LookupResponse, UpdateLookupRequest>({
      query: ({ type, id, displayName }) => ({
        url: `/manage/lookups/${type}/${id}`,
        method: 'PATCH',
        body: { displayName },
      }),
      invalidatesTags: ['Lookup'],
    }),
    deleteLookup: builder.mutation<LookupResponse, DeleteLookupRequest>({
      query: ({ type, id }) => ({
        url: `/manage/lookups/${type}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Lookup'],
    }),
  }),
});

export const {
  useGetLookupsQuery,
  useCreateLookupMutation,
  useUpdateLookupMutation,
  useDeleteLookupMutation,
} = RemarksApi;
